import { overrideChildrenComponentsDataRecursively } from '../../addUtil';
import type { BeforePlugin } from 'types/editorPlugins';

const classicSectionBefore: BeforePlugin = (
  editorAPI,
  originalAddComponentFunc,
  containerRef,
  compDef,
) => {
  if (compDef.components.length) {
    overrideChildrenComponentsDataRecursively(compDef.components);
  }
};

export default classicSectionBefore;
